import { render } from "./complete_online_bank_statement.html?vue&type=template&id=2123b73e&external"
import script from "./complete_online_bank_statement.js?vue&type=script&lang=js&external"
export * from "./complete_online_bank_statement.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__